import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createStoreDeviceInstoreUrl } from "@is/services";
import { StoreDevice } from "@is/types";

export const useStoreDevice = () => {
  const { deviceId, storeId } = useManageApiHeaders();

  const url = createStoreDeviceInstoreUrl({ deviceId, storeId });

  const { data, error, isLoading } = useSWR(url, api.get, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
  });

  return { data: data as StoreDevice, error, isLoading };
};
